export default __webpack_public_path__ + "static/6-3921d13b90f1c6edb9c166d96c9527fc.jpg";